/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.PickListMultiselectFilter = (function () {

    function PickListMultiselectFilter() {
        Monet.UI.Fields.PickListMultiselect.apply(this, arguments);

        this._checkedIds = [];
        this._checkboxes = {};
        this.originalItems = {};
        this.divSelecteds = null;

        this.containerTag = null;
        this.customRequestItems = null;
        this.ulItens = document.createElement('UL');

        var baseElement = null;

        this.createBaseStructure();

        this.createElement = function () {
            this.requestItems();
            this.renderItemsList();
        };

        this.setEntity = function (entity) {
            this.entity = entity;
        };

        var _getCheckId = (function(scope) {

            return function (check) {

                // Este eh para o caso em que os itens do picklist vem do banco, ou seja, tem displayKey
                // e tinhamos que enviar os ids das coisas
                // Ex: LocationType
                return (!scope.displayKey &&  check.value) ? check.value : check.id;
            };
        }(this));

        this.renderItemsList = function (scope) {
            return function (items) {

                if (!baseElement) {

                    scope.containerTag = document.createElement('DIV');

                    var ulVisible = document.createElement('UL');
                    ulVisible.className = 'MonetUIPickListMultiSelecItems dropdownLayer';

                    scope.divSelecteds = document.createElement('DIV');
                    scope.divSelecteds.className = 'selectedItems';

                    var liVisible = document.createElement('LI');

                    liVisible.appendChild(scope.ulItens);
                    liVisible.appendChild(scope.divSelecteds);
                    ulVisible.appendChild(liVisible);

                    liVisible.addEventListener('mouseenter', (event) => {
                        const fieldMuiltSelectYPosition = event.pageY;
                        const listItens = event.currentTarget.firstChild;
                        listItens.style.display = 'block';
                        listItens.style.top = `${fieldMuiltSelectYPosition - event.offsetY}px`;
                    });

                    liVisible.addEventListener('mouseleave', (event) => {
                        const listItens = event.currentTarget.firstChild;
                        listItens.style.display = 'none';
                    });

                    scope.containerTag.appendChild(ulVisible);
                    baseElement = scope.containerTag;

                    this.rootEl.appendChild(scope.containerTag);
                }

                scope.renderListItems(items, scope.ulItens);
                scope.checkSelectedItems();
            };
        }(this);

        this.renderListItems = function (items, ulItens) {

            if (!items) {
                return;
            }

            for (var i = 0; i < items.length; i++) {
                var item = items[i],
                    itemId = _getCheckId(item),
                    li2 = document.createElement('LI'),
                    divCheckBox = document.createElement('DIV'),
                    checkBox = document.createElement('INPUT'),
                    divLabel = document.createElement('DIV'),
                    label = document.createElement('LABEL'),
                    span = document.createElement('SPAN');

                divCheckBox.className = "radio";
                divLabel.className = "text";
                label.setAttribute('for', itemId);
                span.className = 'i18nResource';

                checkBox.type = "checkbox";
                checkBox.id = itemId;

                span.innerHTML = Monet.I18n.getResourcesByKey(item.description);
                label.appendChild(span);

                divLabel.appendChild(label);
                divCheckBox.appendChild(checkBox);

                li2.appendChild(divCheckBox);
                li2.appendChild(divLabel);
                ulItens.appendChild(li2);

                this._checkboxes[itemId] = checkBox;

            }
        };

        this.getFullValue = function () {
            var checks = [];
            for (var i = 0; i < this._checkedIds.length; i++) {
                var checkbox = this.originalItems[this._checkedIds[i]];
                checks.push(checkbox);
            }

            return checks;
        };

        this.getValue = function () {
            var value = null;

            if (this._checkedIds && this._checkedIds.length > 0) {

                if (this.displayKey || this.isAReactField) {
                    value = this._checkedIds;
                } else {
                    value = this._checkedIds.join();
                }

            }

            return value;
        };

        this.setValue = function (checkIds) {
            if (checkIds) {

                if (!this.displayKey && typeof checkIds === 'string') {
                    checkIds = checkIds.split(',');
                }
                this._checkedIds = checkIds;
                this.setInputValue();
                this.updateSelectedItemsLabel();
            }
        };

        this.setInputValue = function () {
            if (this._checkboxes) {
                for (var i = 0; i < this._checkedIds.length; i++) {
                    var checkbox = this._checkboxes[this._checkedIds[i]];
                    this.check(checkbox);
                }

            }
        };

        this.clear = function () {
            if (this._checkboxes) {
                for (var i in this._checkboxes) {
                    this.uncheck(this._checkboxes[i]);
                }
            }

            this._checkedIds = [];

            if (this.divSelecteds) {
                this.divSelecteds.innerHTML = '';
            }
        };

        this.updateSelectedItemsLabel = function () {

            var selected = '';

            if (this.divSelecteds && this.originalItems && Object.keys(this.originalItems).length) {
                for (var i = 0; i < this._checkedIds.length; i++) {
                    var id = this._checkedIds[i];
                    var description = Monet.I18n.getResourcesByKey(this.originalItems[id].description);
                    selected += description + ', ';
                }

                selected = selected.substring(0, selected.length - 2);

                this.divSelecteds.innerHTML = selected;
            }
        };

        this.checkSelectedItems = function () {
            for (var i = 0; i < this._checkedIds.length; i++) {
                var id = this._checkedIds[i];
                this.check(this._checkboxes[id]);
            }
        };

        this.check = function (checkbox) {
            if (checkbox) {
                checkbox.checked = true;

                if (this._checkedIds.indexOf(checkbox.id) === -1) {
                    this._checkedIds.push(checkbox.id);
                }
            }
        };

        this.uncheck = function (checkbox) {
            if (checkbox) {
                checkbox.checked = false;

                var index = this._checkedIds.indexOf(checkbox.id);
                if (index > -1) {
                    this._checkedIds.splice(index, 1);
                }

            }
        };

        this.addCheckListeners = function () {
            for (var key in this._checkboxes) {
                this._checkboxes[key].addEventListener("click", function (context, checkbox) {

                    return function () {

                        if (checkbox.checked) {
                            context.check(checkbox);
                        } else {
                            context.uncheck(checkbox);
                        }

                        context.updateSelectedItemsLabel();
                    };

                }(this, this._checkboxes[key]));
            }
        };

        this.setItemsList = function (context) {
            return function (items) {

                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    context.originalItems[_getCheckId(item)] = item;
                }
            };
        }(this);

        this.successOfRequestData = function (scope) {
            return function (items) {
                if (items) {
                    scope.setItemsList(items);
                    scope.renderListItems(items, scope.ulItens);
                    scope.addCheckListeners();
                    scope.setInputValue();
                    scope.updateSelectedItemsLabel();
                }
            };
        }(this);

        this.requestItems = function (context) {

            return function () {
                if (context.customRequestItems) {
                    context.customRequestItems();
                } else {
                    context.checkPickListTypeAndRequestData(context.successOfRequestData);
                }
            };

        }(this);

        this.getFilterValue = function () {
            return this.getValue();
        };

        this.render = function () {
            this.createElement();
            this.setInputValue();

            return this.rootEl;
        };
    }

    return PickListMultiselectFilter;

}());